import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from 'react-router-dom';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { API_URL } from '../../constants/api';

const LoginDocumentation = () => {
  let domain = window.location.hostname + '';
  domain = domain === 'localhost' ? 'https://db2.wiifews.com' : domain;
  const { email } = useParams();

  const token = getToken();

  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');
  useEffect(() => {
    window.print();
  }, []);
  return (
    <div
      className="container mt-5 p-4 border rounded shadow-lg"
      style={{ maxWidth: '900px', backgroundColor: '#fff' }}
    >
      <div className="text-center mb-4">
        <img
          src={`${API_URL}/${companyLogo}`}
          alt="Company Logo"
          style={{ width: '100px' }}
        />
        <h2 className="mt-2">{companyName}</h2>
      </div>

      <h1 className="mb-4 text-center">System Login Documentation</h1>

      <h2>Domain</h2>
      <p>
        <strong>Website:</strong> <a href={domain}>{domain}</a>
      </p>

      <h2>User Credentials</h2>
      <p>
        <strong>Username (Email):</strong> {email}
      </p>
      <p>
        <strong>Password:</strong> Ktc15@25?
      </p>

      <h2>Login Process</h2>
      <ol>
        <li>
          <strong>Access the Login Page:</strong>
          <ul>
            <li>
              Visit: <a href={domain}>{domain}</a>
            </li>
            <li>Enter the registered email and password.</li>
          </ul>
        </li>
        <li>
          <strong>First-Time Login & Email Activation:</strong>
          <ul>
            <li>Upon first login, an activation email is sent to {email}.</li>
            <li>
              The user must click the activation link to activate their account.
            </li>
            <li>Once activated, the user can proceed with logging in.</li>
          </ul>
        </li>
        <li>
          <strong>
            Register Two-Factor Authentication (2FA) (First-Time Login):
          </strong>
          <ul>
            <li>The user must register for 2FA using Google Authenticator.</li>
            <li>A QR code will be provided for setup.</li>
            <li>After scanning, enter the 6-digit verification code.</li>
          </ul>
        </li>
        <li>
          <strong>Change Default Password (First-Time Login):</strong>
          <ul>
            <li>
              After logging in with 2FA, the user must change the default
              password.
            </li>
            <li>
              Password must be at least 8 characters long with uppercase,
              lowercase, numbers, and special characters.
            </li>
          </ul>
        </li>
      </ol>

      <h2>Two-Factor Authentication (2FA) for Every Login</h2>
      <p>
        Every login requires 2FA authentication using a 6-digit verification
        code.
      </p>

      <h2>Trusted Device Option</h2>
      <p>
        Users can mark their device as "trusted" to skip 2FA for future logins.
      </p>

      <h2>Password Expiry & Notifications</h2>
      <p>
        Passwords expire every 90 days, with notifications sent 10 days before
        expiration.
      </p>

      <h2>Security Measures</h2>
      <ul>
        <li>Strong authentication: Password and 2FA required.</li>
        <li>Device verification: New devices must complete 2FA.</li>
        <li>
          Email activation ensures only verified users can access accounts.
        </li>
        <li>Mandatory 2FA registration for all users.</li>
        <li>Auto logout for inactive sessions.</li>
        <li>Activity tracking includes logins and system navigation.</li>
        <li>Admins can deactivate user accounts.</li>
      </ul>

      <h2>Troubleshooting</h2>
      <ul>
        <li>Forgot password? Use the "Forgot Password" link.</li>
        <li>Lost access to Google Authenticator? Contact support.</li>
        <li>Unable to activate email? Check spam or request a new link.</li>
        <li>
          Contact support at{' '}
          <a href="mailto:support@abc.so">support@kaafiye.com</a>
        </li>
      </ul>
    </div>
  );
};

export default LoginDocumentation;
